import { defineComponent, computed } from '@vue/composition-api';
import { capitalize } from '../../node_modules/@superbet-group/web.lib.utilities/dist/index.esm.js';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';

var script = defineComponent({
    name: 'StaticLink',
    props: {
        path: {
            type: String,
            required: true,
        },
        basePath: {
            type: String,
            required: false,
            default: '/wiki',
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        shouldCapitalize: {
            type: Boolean,
            default: true,
        },
        tag: {
            type: String,
            required: false,
            default: 'a',
        },
    },
    setup: function (props) {
        var translate = useI18n().translate;
        var to = computed(function () {
            return "".concat(props.basePath, "/").concat(props.path);
        });
        var text = computed(function () {
            if (!props.label) {
                return;
            }
            else {
                var translatedText = translate(props.label);
                return props.shouldCapitalize ? capitalize(translatedText) : translatedText;
            }
        });
        return {
            to: to,
            text: text,
        };
    },
});

export default script;
